import { CourseOption } from '../../types/course.response';
import SemesterGridCard from './SemesterCard';

interface SemestersGridProps {
  semesters: string[];
  userCourses: CourseOption[];
  selectedSemester: string;
  onSemesterSelect: (semester: string) => void;
  onAddCourse: (course: CourseOption, semester: string) => void;
  onDeleteCourse: (course: CourseOption) => void;
}

export default function SemestersGrid({ 
  semesters, 
  userCourses, 
  selectedSemester, 
  onSemesterSelect,
  onAddCourse,
  onDeleteCourse,
}: SemestersGridProps) {
  const displayedSemesters = [...semesters].reverse();

  return (
    <div className="w-full">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 items-start" dir="rtl">
        {displayedSemesters.map((semester) => (
          <div key={semester} dir="ltr">
            <SemesterGridCard
              semester={semester}
              userCourses={userCourses}
              isSelected={selectedSemester === semester}
              onSelect={() => onSemesterSelect(semester)}
              onAddCourse={onAddCourse}
              onDeleteCourse={onDeleteCourse}
            />
          </div>
        ))}
      </div>
    </div>
  );
}
